export default __webpack_public_path__ + "static/media/successful-young-couple-becoming-homeowner.24ca2cbc.webp";